module.exports = __webpack_public_path__ + "static/ProjectSettings-969669e91b8e626897668cc4840d21a5.png";